/*
 * DSN for the `app` Sentry project (wundo org). Hardcoded: a DSN is public, and
 * every entry point then reports without extra build configuration. The app's
 * CSP in the infra repo allows this host and reports to this project: change both.
 */
export const SENTRY_DSN =
  'https://602550dc9d3e421adfa9d7841ddf74fb@o4509626312228864.ingest.de.sentry.io/4511767070769232';

/*
 * Microsoft's link scanner (Outlook Safe Links) opens every mailed link in a
 * headless Chrome, and its injected automation rejects promises with this
 * string. No visitor is involved and none of our code produces it.
 */
export const SENTRY_IGNORED_ERRORS = [
  /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
];
